import React from 'react';
import Image from 'next/image';
import Media from '../../models/media';
import Location from '../../models/location';
import styles from './location-marker.module.scss';

type Props = {
  icon?: Media;
  selectedIcon?: Media;
  id: string;
  selected?: boolean;
  setSelected: (...args: any[]) => void;
  location: Location;
  [x: string]: any; // Note: Allow lat & lng props that are only required for the map
};

const LocationMarker = ({
  icon,
  selected,
  id,
  setSelected,
  location,
  selectedIcon
}: Props) => {
  const handleClick = () => {
    setSelected(selected ? null : id);
  };

  return (
    <button
      className={styles['location-marker']}
      onClick={handleClick}
      type="button"
      data-click-type="cta_button"
      data-cta-section={`${location.club} Map Marker`}
      name="map marker"
    >
      <div className={styles['location-marker__container']}>
        {selected && (
          <div className={styles['location-marker__description']}>
            <div className={styles['location-marker__description-name']}>
              {location.club}
            </div>
            <div className={styles['location-marker__description-address']}>
              {location.getFormattedAddress()}
            </div>
            {location.phone && (
              <div className={styles['location-marker__description-phone']}>
                {location.phone}
              </div>
            )}
            {location.email && (
              <div className={styles['location-marker__description-email']}>
                {location.email}
              </div>
            )}
          </div>
        )}
      </div>
      <div className={styles['location-marker__icon']}>
        {!selected && icon && (
          <Image
            alt={icon.alt}
            src={icon.src}
            height={icon.height}
            width={icon.width}
            layout="fixed"
          />
        )}
        {selected && selectedIcon && (
          <Image
            alt={selectedIcon.alt}
            src={selectedIcon.src}
            height={selectedIcon.height}
            width={selectedIcon.width}
            layout="fixed"
          />
        )}
      </div>
    </button>
  );
};

export default LocationMarker;
